import { universalTransferDocumentTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { periodList as classificationTypesPeriodList } from "sources/books/classificationTypes";

export const config = {
    type: {
        label: "Статус УПД",
        inputProps: { name: "type" },
        options: universalTransferDocumentTypes,
        required: true,
        validators: [requiredField],
        unClearable: true,
    },
    classificationTypeId: {
        label: "Тип номенклатуры",
        inputProps: { name: "classificationTypeId" },
        url: classificationTypesPeriodList,
        propName: "name",
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
    },
};

export const initialState = {
    ...getInitialStateFromConfig(config),
    type: "InvoiceAndTransfer",
};
